"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Network;
(function (Network) {
    Network["IGNITE"] = "ignitePass";
    Network["IGNITE_NFT"] = "igniteNftPass";
})(Network || (Network = {}));
const defaultConfiguration = {
    networkAddressMappings: {
        // test networks
        tigoYhp9SpCDoCQmXGj2im5xa3mnjR1zuXrpCJ5ZRmi: Network.IGNITE,
        tig2iQjtihM8GbWS1z5LJi9ytTkj4poeh2N3MW4n9gt: Network.IGNITE_NFT,
        // production networks
        ignREusXmGrscGNUesoU9mxfds9AiYTezUKex2PsZV6: Network.IGNITE,
        ign2PJfwxvYxAZpMdXgLdY4VLCnChPZWjtTeQwQfQdc: Network.IGNITE_NFT,
    },
    networkConfigs: {
        requiresGatekeeperRecordStatusCheck: true,
        pollChainIntervalMilliseconds: 2000,
        pollChainNumberRetries: 30,
        [Network.IGNITE]: {
            requiresGatekeeperRecordStatusCheck: true,
        },
        [Network.IGNITE_NFT]: {
            requiresGatekeeperRecordStatusCheck: true,
        },
    },
};
const config = (gatekeeperNetwork) => {
    var _a;
    const networkName = gatekeeperNetwork ? defaultConfiguration.networkAddressMappings[gatekeeperNetwork] : null;
    const networkConfig = networkName ? defaultConfiguration.networkConfigs[networkName] : null;
    const { pollChainIntervalMilliseconds, pollChainNumberRetries } = defaultConfiguration.networkConfigs;
    return {
        pollChainNumberRetries,
        pollChainIntervalMilliseconds,
        requiresGatekeeperRecordStatusCheck: (_a = networkConfig === null || networkConfig === void 0 ? void 0 : networkConfig.requiresGatekeeperRecordStatusCheck) !== null && _a !== void 0 ? _a : defaultConfiguration.networkConfigs.requiresGatekeeperRecordStatusCheck,
    };
};
exports.default = config;
